<div class="recovery-container">
  <!-- Close Icon -->
  <i [mat-dialog-close] class="fas fa-times close-icon"></i>

  <!-- Title -->
  <h2 class="public-form-title">Recuperar contraseña</h2>
  <p>
    Se envió un mensaje de recuperación al email ingresado. Seguí las
    instrucciones del email para recuperar el acceso a tu cuenta.
  </p>
</div>
